export enum MetersCardTab {
  Pasport = 'pasport',
  Update = 'update',
  Replace = 'replace',
  Install = 'install',
  Service = 'service',
}
